<template>
    <div id="app">
        <file-pond
                name="test"
                ref="pond"
                :label-idle="content"
                :accepted-file-types="accepted"
                @change="uploadFileHandler"
                v-bind:files="myFiles"
                v-on:init="handleFilePondInit"
                v-on:addfile="handleFilePondAdd"
                v-on:removefile="handleFilePondRemove"
                v-bind:allow-multiple="allowMultiple"
                v-on:FilePond:processfiles="test"
        />
    </div>
</template>

<script>
    // Import FilePond
    import vueFilePond from 'vue-filepond';

    // Import plugins
    import FilePondPluginFileValidateType
        from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

    // Import styles
    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    // Create FilePond component
    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

    export default {
        name: 'app',
        props: ['allowMultiple', 'content', 'accepted'],
        data: function () {
            return {myFiles: []};
        },
        methods: {
            handleFilePondInit: function () {
                if (process.env.VUE_ENV === 'development')
                    console.log('FilePond has initialized');

                // example of instance method call on pond reference
                this.$refs.pond.getFiles();
            },
            handleFilePondAdd: function (error, file) {
                if (process.env.VUE_ENV === 'development')
                    console.log('FilePond has added');
                this.$emit('fileUpload', file)
            },

            handleFilePondRemove: function (error, file) {
                if (process.env.VUE_ENV === 'development')
                    console.log('FilePond has removed');
                this.$emit('fileRemove', file)
            },
            test: function (error, file) {
                if (process.env.VUE_ENV === 'development')
                    console.log('Test => ', file);
            },
        },
        components: {
            FilePond,
        },
    };
</script>
<style>

    .filepond--root .filepond--drop-label {
        background-color: transparent !important;
    }

    /*.filepond--root .filepond--drop-label {*/
    /*    background-color: #021A24;*/
    /*}*/

    .filepond--wrapper .filepond--root .filepond--credits {
        display: none
    }

    .filepond--panel-root {
        background-color: transparent
    }

</style>